import type { ComponentProps } from "react";
import { ToolIcon } from "@theorgchartdev/storybook";
import { gWhiteLabel } from "@coreapp/whitelabel/brand";
import { enumBrand } from "@coreapp/constants";
import { useMainNavItems } from "./useMainNavItems";
import { NavItemUpgradeBadge } from "./NavItemUpgradeBadge";

type HeaderNavIconProps = {
  itemKey: string;
  size?: ComponentProps<typeof ToolIcon>["size"];
};

const NavIconByKey = ({ itemKey, size }: HeaderNavIconProps) => {
  const { namedOptions } = useMainNavItems();
  const item = namedOptions[itemKey];
  if (!item) return null;

  const icon = (
    <ToolIcon
      name={item.icon}
      size={size}
      title={item.name}
      ariaLabel={item.name}
      dataTestId={
        item.showUpgrade ? `main-nav-icon-upgrade-${item.name}` : `main-nav-icon-${item.name}`
      }
      shape="round"
      disabled={item.disabled}
      onClick={item.showUpgrade ? undefined : item.onClick}
    />
  );

  if (item.showUpgrade) {
    return <NavItemUpgradeBadge item={item}>{icon}</NavItemUpgradeBadge>;
  }

  return icon;
};

// Gated here rather than inside NavIconByKey, since a hook can't be called
// conditionally within the component that owns it.
export const HeaderNavIcon = ({ itemKey, size }: HeaderNavIconProps) =>
  gWhiteLabel === enumBrand.isolved ? <NavIconByKey itemKey={itemKey} size={size} /> : null;
